module.exports = __webpack_public_path__ + "static/media/previousBlackArrow.5715f8c6.svg";